import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { Skeleton } from '@jira/platform__periscope/src/ui/skeleton/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { softwarePeriscopeNextGenRoute } from '@jira/router-routes__software-periscope-routes/src/softwarePeriscopeNextGenRoute.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { rovoEntitlementResource } from '@jira/router-resources__rovo-entitlement/src/useRovoEntitlementResource.tsx';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud
import { isFedRamp } from '@atlassian/atl-context';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { GSNPeriscopeEntryPoint, periscopeEntryPoint } from './common/periscope.tsx';

export const softwarePeriscopeNextGenRouteEntry: Route = createEntry(
	softwarePeriscopeNextGenRoute,
	() => ({
		group: 'software',
		skeleton: Skeleton,
		layout: softwareProjectLayoutNoOnboarding,
		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},
		resources: [
			...getNavigationResources(
				fg('navx-global-side-nav') ? { isUsingSidebarEntrypoint: true } : undefined,
			),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			rovoEntitlementResource,
		],
		entryPoint: () => {
			if (isFedRamp()) {
				// JOLT-2765: FedRAMP tenants are blocked from Periscope by default.
				// An AEM allowlist check lets individual FedRAMP tenants opt in.
				if (!isFeatureEnabled('jira', 'jira-development-tab')) {
					return notFoundPageEntrypoint;
				}
			}
			if (fg('navx-global-side-nav')) {
				return GSNPeriscopeEntryPoint;
			}
			return periscopeEntryPoint;
		},
		meta: {
			reporting: {
				id: 'software-periscope',
				packageName: camelCase('software-periscope'),
				teamName: 'jolt',
			},
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
